import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to the element matching the URL #anchor (e.g. /el-fordele#laderabat).
// Runs after the layout's scroll-to-top so anchor links land on the right section.
export default function useHashScroll() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 350);
    return () => clearTimeout(t);
  }, [hash]);
}